import { Injectable, Inject } from '@angular/core';
import { forkJoin, fromEvent, Observable, of } from 'rxjs';
import { GenericResponse } from '@shared/models/GenericResponse';
import { environment } from '@env';
import { HttpHandlerService } from '@shared/services/http-handler.service';
import { DOCUMENT } from '@angular/common';
import { map, switchMap, take } from 'rxjs/operators';
import { ArrayUtils } from '@shared/utils/array.utils';
import { HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '@app/authentication/authentication.service';
import { FeatureFlagService } from '@shared/services/feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class FileStorageService {

  constructor(
    private http: HttpHandlerService,
    @Inject(DOCUMENT) private doc: Document,
    private auth: AuthenticationService,
    private ff: FeatureFlagService
  ) { }

  public store(file: any, accountingId: string, storageBucket = environment.storageApplicationId): Observable<GenericResponse<{ id: string }>> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${environment.storageBaseUrl}/storage/${storageBucket}/accounting/${accountingId}/store`;
    return this.http.post<GenericResponse<any>>(url, formData, 'Falha ao armazenar arquivo!');
  }

  public storeMultiple(files: any[], accountingId: string, storageBucket = environment.storageApplicationId) {
    const uploads$ = files.map(file => this.store(file, accountingId, storageBucket));
    return forkJoin(uploads$);
  }

  getResourceURL(resourceId: string): string {
    return `${environment.storageBaseUrl}/storage/${resourceId}`;
  }

  public storeInS3(file: any, filename = file.name) {
    const formData = new FormData();

    formData.append('file', file, filename);
    formData.append('applicationId', 'account-avatar');

    return this.http.post<{ uuid: string }>(
        `${environment.ottimizzaStorageUrlAWS}/api/v1/arquivos`,
        formData,
        'Falha ao armazenar arquivo!',
        undefined,
        this.httpHeaders()
    );
  }

  public storeMultipleS3(files: any[]) {
    const uploads$ = files.map(file => this.storeInS3(file, file.name));
    return forkJoin(uploads$);
  }

  getResourceURLS3(id: string) {
    return `${environment.ottimizzaStorageUrlAWS}/app/v1/arquivos/inout/${id}/download/tareffa`;
  }

  public selectFiles(multiple = false, accepted?: string[]) {
    const input = this.doc.createElement('input');
    input.type = 'file';
    input.multiple = multiple;
    if (accepted?.length) {
      input.accept = accepted.join(',');
    }

    const listener = fromEvent(input, 'change')
    .pipe(map(() => {
      const files = input.files;
      return ArrayUtils.listToArray(files);
    }));

    input.click();

    return listener;
  }

  public selectAndStore(multiple = false, accountingId: string, bucket = environment.storageApplicationId) {
    return this.selectFiles(multiple)
    .pipe(
      switchMap(files => this.storeMultipleS3(files)),
      map(records => ({ records }) as GenericResponse<any>),
    );
  }

  public download(resourceId: string) {
    window.open(this.getResourceURL(resourceId) + '/download', '_blank');
  }

    private httpHeaders(): any {
        return {
            headers: new HttpHeaders({
                Authorization: `Bearer ${this.auth.getAccessToken()}`,
            }),
        };
    }

}
